/**
 * @overview 签到列表
 * @author 3173
 * @date 2019-2-24
 */
import React from 'react';
import ReactDOM from 'react-dom'
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import 'antd/dist/antd.css';
import {Col, Row, Spin} from 'antd';
import '../../../styles/containers/face/sign/style.less';
import DataSet from "@antv/data-set";
import createColumns from "./signListColumns";
import {WizModalUserIdentityShow} from '@/containers/common';

let {WizContainer, WizReduxTemplatem, modelUtils} = framework_tool;
let {WizCard, WizIcon, WizTable, WizButton, WizPopconfirm, WizModal, WizG2Plot, WizTabs, WizSearchBar, WizDataTable, WizBizcharts, WizText, WizAlert, WizBrowserExport} = component_tool;
let {checkStrLength, getPageData, Session} = utils_tool;

let {Chart, Geom, Axis, Tooltip, Coord, Legend, Guide,} = WizBizcharts;
const {Text, Html} = Guide;

class SignInList extends WizContainer {

  componentName = 'SignInList';

  constructor(props) {
    super(props);
    this.state = {
      tabKey: 'detailed',
      signType: 1,//签到列表,0为获取未签到列表
      selectedRows: 0,
      rows: [],
      apiParams: {},
      classStudentRecord: {},
      showUserPersonInfoVisible: false,
    }
    this.signId = null;
    this.classId = null;
    this.signName = null;
  }

  _componentWillMount() {
    const {history} = this.props;
    if (history.location && history.location.record) {
      Session.set('signInListRecord', history.location.record);
      this.signId = history.location.record.id;
      this.classId = history.location.record.classId;
      this.signName = history.location.record.name;
    } else if (Session.get('signInListRecord')) {
      this.signId = Session.get('signInListRecord').id;
      this.classId = Session.get('signInListRecord').classId;
      this.signName = Session.get('signInListRecord').name;
    }
  }

  _componentDidMount() {
    const {history} = this.props;
    this.getSignInList(1);//默认获取签到明细
    //this.getSignInSituation();

    //图表需要在请求接口后加载
    //this.ring()
  }

  /**获取签到列表（补签/明细） */
  getSignInList(type, other = {}) {
    if (this.signId) {
      let apiParams = {signId: this.signId, ...this.state.apiParams}
      if (type == 0) {
        apiParams.status = 0
      }
      this.doAction({
        path: 'studentSign/listByPage',
        payload: {
          key: 'studentSign' + type,
          apiParams: {...apiParams, ...other}
        },
        autoInit: true,
      })
    }
  }

  /**获取签到概况 */
  getSignInSituation() {
    if (this.signId) {
      this.doAction({
        path: 'sign/getSignDetailById',
        payload: {
          key: 'getSignDetailById',
          apiParams: {id: this.signId}
        },
        autoInit: true,
      })
    }
  }

  /**导出 */
  exportStudentSign(type) {
    if (this.signId) {
      let apiParams = {signId: this.signId, ...this.state.apiParams};
      if (type == 0) {
        apiParams.status = 0
      }
      this.doAction({
        path: 'studentSign/listByCondition',
        payload: {
          key: 'exportStudentSign',
          apiParams: {...apiParams}
        },
        autoInit: true,
      })
    }
  }

  /**补签 */
  supplementarySign(record) {
    if (record && record.id) {
      let idList = [];
      idList.push(record.id);
      let content = '您确定要对该项进行补签操作吗？';
      this.saveRepairStudentSign(idList, content);
    }
  }

  saveRepairStudentSign(idList, content) {
    if (!content) {
      content = '您确认需要进行该操作吗';
    }
    if (idList && idList.length) {
      WizModal.confirm({
        title: "注意",
        content,
        onOk: () => {
          this.doAction({
            path: 'studentSign/setStudentSignStatusByBatch',
            payload: {
              key: 'setStudentSignStatusByBatch',
              apiParams: {
                idList: idList,
                status: 2,
              }
            }
          });
        },
        onCancel() {
        }
      });

    }
  }

  propsAndStateOnChange = {
    signDetail: this.getSignDetail.bind(this),
    studentSign0: this.getStudentList0.bind(this),
    studentSign1: this.getStudentList1.bind(this),
    exportStudentSign: this.getExportDataOver.bind(this),
    setStudentSignStatusByBatch: this.updateStudentSignStatusOver.bind(this),
    getClassStudentInfo: this._getClassStudentInfoOver.bind(this),
  };

  /**
   * 获取班级人员信息
   * @param nextProps
   * @param nextState
   * @returns {boolean}
   * @private
   */
  _getClassStudentInfoOver(nextProps, nextState) {
    const classStudentInfo = nextProps.getClassStudentInfo.data;
    if (nextProps.getClassStudentInfo.code == 1) {
      let classStudentRecord = {};
      if (classStudentInfo && classStudentInfo.length) {
        classStudentRecord = classStudentInfo[0];
      }
      this.setState({
        classStudentRecord: classStudentRecord,
        showUserPersonInfoVisible: true,
      })
    } else {
      wizNotice.error('查看失败：' + nextProps.getClassStudentInfo.msg);
    }
    return true;
  }

  getSignDetail(nextProps, nextState) {
    if (nextProps.signDetail.code == 1) {
      this.ring(nextProps.signDetail)
    }
    return true;
  }

  getStudentList0(nextProps, nextState) {
    let signList = nextProps.studentSign0.records;
    if (signList && signList instanceof Array) {
      this.getSignInSituation();

      signList.forEach(sign => {
        sign.signTimes = sign.startDate + '~' + sign.endDate
      });
    }

    return true;
  }

  getStudentList1(nextProps, nextState) {
    let signList = nextProps.studentSign1.records;
    if (signList && signList instanceof Array) {
      this.getSignInSituation();

      signList.forEach(sign => {
        sign.signTimes = sign.startDate + '~' + sign.endDate
      });

    }
    return true;
  }

  getExportDataOver(nextProps, nextState) {
    if (nextProps.exportStudentSign.code == 1) {
      let signList = nextProps.exportStudentSign.data;
      signList.forEach(sign => {
        sign.signTimes = sign.startDate + '~' + sign.endDate
        if(sign.status!=2){
          sign.createrName = '';
          sign.signDate = '';
        }
      });
      let title = "签到详情";
      if (this.state.signType == 0) {
        title = "未签到详情";
      }

      let columnDefs = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'center',
            padding: '5px 0',
            color: '#595959',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
          },
        },
        {
          headerName: '账号',
          field: 'userName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'center'},
          },
        },
        {
          headerName: '姓名',
          field: 'fullName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'center'},
          },
        },
        {
          headerName: '手机号',
          field: 'mobile',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'center'},
          },
        },
        {
          headerName: '证件号码',
          field: 'idCard',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'center'},
          },
        },
        {
          headerName: '用户属性',
          field: 'userTypeName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'center'},
          },
        },
        {
          headerName: '签到时间段',
          field: 'signTimes',
          width: 35,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'center'},
          },
        },
        {
          headerName: '状态',
          field: 'statusName',
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'center'},
          },
        },
        {
          headerName: '补签时间',
          field: 'signDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'center'},
          },
        },
        {
          headerName: '补签操作人',
          field: 'createrName',
          width: 15,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'center'},
          },
        }
      ];
      WizBrowserExport({
        title: title,
        sheetName: title,
        columns: columnDefs.filter((_, index) => index),
        rows: signList,
        filename: title + '.xlsx',
      })
    }
    return true;
  }

  /**
   * 批量补签返回结果
   * @param nextProps
   * @param nextState
   */
  updateStudentSignStatusOver(nextProps, nextState) {
    if (nextProps.setStudentSignStatusByBatch.code == 1) {
      this.getSignInList(0);
      wizNotice.success('补签成功');
    } else {
      wizNotice.error('补签失败：' + nextProps.setStudentSignStatusByBatch.msg);
    }
  }

  /**把state里的数据处理成对应的关联数据结构给后台保存 */
  arrange() {
    let result = [];
    this.state.powerData.forEach(data => {
      //先增加角色与菜单关联
      result.push({
        menuId: this.state.menuId,
        roleId: data.roleId,
      })
      //增加角色与菜单的元素关联
      data.elementIds.forEach(elementId => {
        if (elementId != 0) {
          result.push({
            menuId: this.state.menuId,
            roleId: data.roleId,
            elementsId: elementId,
          })
        }
      })
    })
    return result;
  }


  ring(signDetail) {
    const data = [
      {
        "type": "已签到人数",
        "count": signDetail.data.signCount,
        "rate": signDetail.data.signRate,
        "serie": "default"
      },
      {
        "type": "未签到人数",
        "count": signDetail.data.noSignCount,
        "rate": signDetail.data.noSignRate,
        "serie": "default"
      }
    ];
    const ds = new DataSet();

    const dv = ds.createView().source(data).transform({
      type: "percent",
      field: "count",
      dimension: "type",
      as: "percent"
    });
    ReactDOM.render((
      <Chart data={data} width={400} height={166} padding={[25, 25, 25, -205]}>
        <Coord type="theta" innerRadius={0.74}/>
        <Tooltip showTitle={false}/>
        <Legend
          position="right-center"
          offsetX={-200}
          textStyle={{
            fill: '#404040', // 文本的颜色
            fontSize: '12', // 文本大小
          }}
          itemFormatter={(val) => {
            let rate = "";
            let c = "";
            data.forEach(d => {
              if (d['type'] === val) {
                if (d['rate']) {
                  rate = '  |  ' + d['rate'];
                }
                if (d['count']) {
                  c = '  |  ' + d['count'];
                }
              }
            });
            return val + rate + c;
          }}
        />
        <Geom type="intervalStack" position="count" color={['type', ['#43CD80', 'red']]}/>
        <Guide>
          <Text
            position={["50%", "38%"]}
            content="参训人数"
            style={{
              lineHeight: "40px",
              fontSize: "12",
              fill: "#6E7B8B",
              textAlign: "center"
            }}
          />
          <Text
            position={["50%", "62%"]}
            content={signDetail.data.totalCount}
            style={{
              lineHeight: "40px",
              fontSize: "14",
              fill: "#1E1E1E",
              textAlign: "center"
            }}
          />
        </Guide>
      </Chart>
    ), document.getElementById('ring'));
  }


  _onChange = (key) => {
    if (this.state.tabKey !== key) {
      let signType = 1;
      if (key == 'wait') {
        signType = 0;
        this.getSignInList(0);
      } else {
        this.getSignInList(1);
      }
      this.setState({
        tabKey: key,
        signType: signType,
        apiParams: {},
        time: new Date().getTime()
      });
    }
  }

  _removeSelectedRows = () => {
    this.setState({
      selectedRows: 0,
      rows: [],
    })
  };

  /**签到列表 */
  signList() {
    const {history, studentSignLoading} = this.props;
    let {selectedRows, rows, signType} = this.state;
    let signList = this.props.studentSign1;
    let supplementary = false;
    let sColumns = [{
      title: '姓名',
      name: 'fullName',
      searchItem: {},
    },
      {
        title: '账号',
        name: 'userName',
        searchItem: {},
      }]

    if (signType == 0) {
      signList = this.props.studentSign0;
      supplementary = true;
    } else {
      sColumns.push({
        title: '状态',
        name: 'status',
        searchItem: {type: "select"},
        dict: [
          {code: 0, codeName: "未签到"},
          {code: 1, codeName: "已签到"},
          {code: 2, codeName: "补签"}
        ],
      })
    }
    const searchBarProps = {
      columns: sColumns,
      onSearch: (values, isReset) => {

        this.setState({apiParams: values || {}, time: new Date().getTime()}, () => {
          this.getSignInList(signType)
        })
      }
    };
    let columns = createColumns(this, {}, supplementary);
    let dataItems = getPageData(signList);
    let dataTableProps = {
      loading: false,
      columns,
      dataItems: dataItems,
      rowKey: "id",
      selectType: "checkbox",
      showNum: false,
      isScroll: true,
      onChange: ({pageNum, pageSize}) => {
        this.getSignInList(signType, {current: pageNum, size: pageSize});
      },
      selectedRowKeys: rows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        this.keys = keys;
        this.setState({
          rows,
          selectedRows: rows.length
        })
      }
    };
    return (
      <>
        <WizSearchBar type="grid"
                      {...searchBarProps}
                      cols={{xs: 14, md: 12, xl: 10}}
        />
        <WizCard className="mt-15">
          <WizButton.WizGroup>
            {supplementary ?
              <WizButton title="批量补签" disabled={!rows.length} type="primary"
                         onClick={e => this._handleRepairStudentSign(rows, selectedRows)}>批量补签</WizButton>
              : null
            }
            <WizButton title="导出" onClick={e => this.exportStudentSign(signType)}>导出</WizButton>
          </WizButton.WizGroup>
          <WizAlert
            type="info"
            message={<Message selectedRows={selectedRows} removeSelectedRows={this._removeSelectedRows}/>}
            showIcon
            style={{marginBottom: 15}}
          />
          <WizDataTable {...dataTableProps} />
          <div style={{margin: "20px auto", "text-align": "center"}}>
            <WizDataTable.Pagination {...dataTableProps} />
          </div>
        </WizCard>
      </>
    )
  }

  /**
   * 批量补签学员
   */
  _handleRepairStudentSign = (rows) => {
    if (rows && rows instanceof Array && rows.length > 0) {
      let idList = [];
      rows.forEach(key => {
        const {id} = key;
        idList.push(id);
      });
      let content = '您确定要对这'+rows.length+'项进行批量补签操作吗？';
      this.saveRepairStudentSign(idList, content);
    } else {
      wizNotice.warn('请先选择学员，再行操作！');
    }
  };

  /**
   * 获取查看学员班级任职信息
   * @param classResultRecord
   * @private
   */
  _showUserPersonModal = (record) => {
    const {personId} = record;
    let classId = this.classId;
    if (personId && classId) {
      this.doAction({
        path: 'classStudentManagement/getList',
        payload: {
          key: 'getClassStudentInfo',
          apiParams: {
            personId,
            classInfoId:classId,
          }
        }
      });
    }
  };

  _render() {
    const {history, studentSignLoading, signLoading,classStudentManagementLoading} = this.props;
    let {selectedRows, rows, showUserPersonInfoVisible, classStudentRecord} = this.state;
    let lookUserPersonInfoModal = {
      title: '查看已选任职',
      visible: showUserPersonInfoVisible,
      personId: classStudentRecord.personId ? classStudentRecord.personId : null,
      orgId: classStudentRecord.orgId ? classStudentRecord.orgId : null,
      positionId: classStudentRecord.positionId ? classStudentRecord.positionId : null,
      onCancel: (e) => {
        this.setState({
          showUserPersonInfoVisible: false,
          classStudentRecord: {},
        });
      },
    };
    let waitSign = '待补签' + (this.props.signDetail&&this.props.signDetail.data&&this.props.signDetail.data.noSignCount ? '('+this.props.signDetail.data.noSignCount+')':'' );
    
    return (
      <Spin tip={'加载中'} spinning={studentSignLoading || signLoading || classStudentManagementLoading}>
        <WizCard title={'签到概况'}>
          <Row>
            <Col span={4} push={2}>
              <span className="header-fixed-font">名称:</span>
              <span className="header-title-font"> {this.signName}</span>
            </Col>
            <Col span={16} push={2}>
              <div className="header-fixed-font">班级中所有签到时间段均完成的人员才计算为已签到</div>
            </Col>
          </Row>
          <Row>
            <Col span={16} push={6} style={{marginBottom: 0,}}>
              <div id='ring' style={{marginBottom: -40, marginTop: -8}}/>
            </Col>
          </Row>
        </WizCard>
        <WizCard>
          <WizTabs animated={false} defaultActiveKey="detailed" onChange={this._onChange.bind(this)}>
            <WizTabs.TabPane tab="签到明细" key="detailed">
              {this.state.tabKey === 'detailed' ? this.signList() : null}
            </WizTabs.TabPane>
            <WizTabs.TabPane tab={waitSign} key="wait">
              {this.state.tabKey === 'wait' ? this.signList() : null}
            </WizTabs.TabPane>
          </WizTabs>
        </WizCard>
        <WizModalUserIdentityShow {...lookUserPersonInfoModal}/>
      </Spin>
    )
  }
}

const Message = ({selectedRows, removeSelectedRows}) => (
  <>
    已选择 {selectedRows} 项
    <WizButton
      style={{height: 20}}
      type="link"
      tooltip="清空"
      onClick={() => removeSelectedRows()}
    >
      {" "}
      清空
    </WizButton>
  </>
);

const mapStateToProps = (state, ownProps) => {
  const {studentSign, sign,classStudentManagement} = state;
  const signDetail = modelUtils.getModelEntity(sign, "getSignDetailById");
  const studentSign0 = modelUtils.getModelEntity(studentSign, "studentSign0");
  const studentSign1 = modelUtils.getModelEntity(studentSign, "studentSign1");
  const exportStudentSign = modelUtils.getModelEntity(studentSign, "exportStudentSign");
  const setStudentSignStatusByBatch = modelUtils.getModelEntity(studentSign, "setStudentSignStatusByBatch");
  const getClassStudentInfo = modelUtils.getModelEntity(classStudentManagement, "getClassStudentInfo");
  const load = modelUtils.getLoadingState(state, ['studentSign', 'sign', 'classStudentManagement']);
  return {
    signDetail: signDetail,
    studentSign0: studentSign0.data,
    studentSign1: studentSign1.data,
    setStudentSignStatusByBatch: setStudentSignStatusByBatch,
    exportStudentSign: exportStudentSign,
    getClassStudentInfo: getClassStudentInfo,
    ...load
  }
};

export default connect(mapStateToProps)(SignInList);
